import React from 'react'
import QuestionsBlock from '~/components/questions-block'
import {ICountryCode, phoneNumsLib} from "~/components/pages/partners/constans";
import {useAppSelector} from "~/hooks/redux";

interface IQuestions {
  header: string,
  description: string | React.ReactNode
}

export const Questions: React.FC = () => {
  return (
    <div className='onlinepbx__partners__question'>
      <div className='onlinepbx__container'>
        <h2 className='onlinepbx__content__header__center'>
          Часто задаваемые вопросы
        </h2>
        {QuestionsBlock(getQuestions())}
      </div>
    </div>
  )
}

const getQuestions = (): IQuestions[] => {
  const { country } = useAppSelector(state => state.countryReducer);

  const selectedCountryValue: ICountryCode = country.value;

  const getPhone = () => {
    return phoneNumsLib[selectedCountryValue] || phoneNumsLib.UZ
  }

  const getPhoneLink = (phone: string) => {
    return phone.replace(/\D/g, '')
  }

  const link = (process.env.SERVER_NODE_ENV === 'production' && 'https://partners.onlinepbx.ru/register') ||
    (process.env.SERVER_NODE_ENV === 'stage' && 'https://partners.stage.onlinepbx.ru/register') ||
    'https://partners.test.onlinepbx.ru/register'
  return [
    {
      header: 'Кто может стать партнером?',
      description: <div className='onlinepbx__question__description'>
        Партнером может стать индивидуальный <br/>предприниматель или юридическое лицо. Физические <br/>лица и самозанятые не могут участвовать в партнерской <br/>программе onlinepbx.
      </div>
    }, {
    header: 'Где найти полезные материалы о сервисе?',
    description: <div className='onlinepbx__question__description'>
      В нашей
      <a
        target='_blank'
        href='https://onlinepbx.evateam.ru/docs/docs/CmfProject:e6966c84-48a9-11ee-848f-00161e050156#baza-znanij-online-pbx'
        className='onlinepbx__question__description__link'>
        базе знаний
      </a>.
    </div>
  }, {
    header: 'Как настроить сервис? Куда обращаться?',
    description: <div className='onlinepbx__question__description'>
      Вы можете настроить сервис самостоятельно по
      <a
        href='https://onlinepbx.evateam.ru/docs/docs/DOC-000085#bystryj-start-v-online-pbx'
        target='_blank'
        className='onlinepbx__question__description__link'>
        инструкции
      </a>, либо связаться с технической поддержкой по телефону
      <a
        href={`tel:+${getPhoneLink(getPhone().ts)}`}
        className='onlinepbx__question__description__link'>
        {getPhone().ts}
      </a>. Наши специалисты бесплатно помогут с настройкой и ответят на вопросы.
    </div>
  }, {
    header: 'С кем я могу обсудить условия партнерской программы \nи возможности сервиса?',
    description: <div className='onlinepbx__question__description'>
      Вы можете обратиться к нашему менеджеру партнерской программы по телефону
      <a
        href={`tel:+${getPhoneLink(getPhone().pd)}`}
        className='onlinepbx__question__description__link'>
        {getPhone().pd}
      </a>, написать на почту<br/><a
        href='mailto:partner@onlinepbx.ru'
        className='onlinepbx__question__description__link onlinepbx__question__description__link__no__margin'>
        partner@onlinepbx.ru&nbsp;
      </a>
      или в telegram-бот <a
        href='https://t.me/onlinepbx_sales'
        target='_blank'
        rel='noopener noreferrer'
        className='onlinepbx__question__description__link onlinepbx__question__description__link__no__margin'>
        @onlinepbx_sales
      </a>
    </div>
  }, {
    header: 'Могу ли я получить эксклюзивные права на продажу вашего сервиса (white label)?',
    description: <div className='onlinepbx__question__description'>
      К сожалению, партнерская программа не предусматривает эксклюзивные права на продажу продукта.
    </div>
  }]
}

export default Questions
